import { Constants } from "./../../_helpers/constants-handle";
import { Component, OnInit, OnDestroy, Renderer2, ElementRef } from "@angular/core";
import { DrawService, AlertService, CommonService, AuthenticationService, ToastService } from "../../_services";
import { filter, delay, first } from "rxjs/operators";
import { Router, ActivationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CurrencySymbolPipe, CustomCurrencyPipe } from "src/app/_directives";

@Component({
  selector: ".game-zone",
  templateUrl: './mini-roulette.component.html',
  // selector: 'app-mini-roulette',
  // styleUrls: ['./mini-roulette.component.css']
})

export class MiniRouletteComponent implements OnInit, OnDestroy {

  gameCode = Constants.MINI_ROULETTE;
  gameId;
  panelCounter = 1;
  panelNumberCounter;
  gameData: any;
  userData: any;
  gameDataSubscription: any;
  rootData: any;
  betAmtArray = [];
  otherAmtVal = '';
  showOtherAmountInput = false;
  betData = {};
  otherBetAmountMultiple = 0;
  betError = '';
  userInfo: any;
  timeIntervalContainer: any;
  tempCounter = 0;
  fetchDataStatus = false;
  diff_time: any;
  resetPlaySubscription: any;
  postState = true;
  postStateMsg = '';
  userInfoLocalSubscription: any;
  notifyDrawMachineSubscription: any;
  postStateInterval: any;
  gameFetchCounter = 0;
  myTicketCount = 0;
  ticketListSubscription: any;
  notifyTktLstSubscription: any;
  clientCode = Constants.CLIENT_CODE;
  saleTimerStatus = false;
  iconMapping = Constants[Constants.ONE_BY_TWELVE + '_ICON_MAPPING'];
  panelTotNumbersArray: any;
  defaultBetAmountMultiple;
  updateUserDataSubscription: any;
  activeDrawStatus = true;
  loadLobby = true;
  routeSubscription: any;
  clearPickValues: boolean = false;
  constructor(
    private drawService: DrawService,
    private alertService: AlertService,
    private renderer: Renderer2,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private router: Router,
    private el: ElementRef,
  ) {
    this.rootData = Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameCode];
    this.routeSubscription = router.events.pipe(
      filter(e => e instanceof ActivationEnd),
      first()
    ).subscribe(val => {
      let tempVar = <any>val;
      let params = tempVar.snapshot.params;
      if (typeof params.playerid != 'undefined' && typeof params.playername != 'undefined' &&
        typeof params.sessid != 'undefined' && typeof params.bal != 'undefined' &&
        typeof params.lang != 'undefined' && typeof params.curr != 'undefined' &&
        typeof params.alias != 'undefined' && typeof params.isMobileApp != 'undefined') {
        this.loadLobby = false;
      }
      if(params.isMobileApp == 0) {
        this.loadLobby = true;
      }
      this.commonService.iframe_resize();
    });
  }

  ngOnInit() {
    this.commonService.addEngineClass();
    this.gameDataSubscription = this.drawService.subscribeGameData().pipe(
      delay(0),
      filter(response => response != null && typeof response.data.responseData.gameRespVOs[0].numberConfig != 'undefined'))
      .subscribe((response: any) => {
        response.data.responseData.gameRespVOs.forEach(element => {
          if (element.gameCode == this.gameCode) {
            this.renderer.addClass(document.body, 'screen_type_single');
            this.gameData = JSON.parse(JSON.stringify(element));
            this.gameId = element.id;
            if (this.gameFetchCounter == 0) {
              if (response.timerType == this.gameCode || response.timerType == '') {
                this.resetUserData();
              }
            }
            this.betAmtArray = [];
            for (let i = 0; i < element.betRespVOs.length; i++) {
              this.betData[element.betRespVOs[i].betCode] = JSON.parse(JSON.stringify(element.betRespVOs[i]));
              let tempVar = {};
              let tempPickCounter = 0;
              for (let j = 0; j < this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType.length; j++) {
                tempVar[element.betRespVOs[i].pickTypeData.pickType[j].code] = this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType[j];
              }
              this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType = tempVar;
            }
            let betArrayLength = Math.floor(element.betRespVOs[0].maxBetAmtMul);
            betArrayLength = (betArrayLength > 8) ? 9 : betArrayLength;
            if (element.betRespVOs[0].unitPrice < 1) {
              for (let i = 1; i <= betArrayLength; i++) {
                if (element.betRespVOs[0].unitPrice * i * 10 <= element.betRespVOs[0].maxBetAmtMul * element.betRespVOs[0].unitPrice) {
                  this.betAmtArray.push(element.betRespVOs[0].unitPrice * i * 10);
                }
              }
            } else {
              for (let i = 1; i <= betArrayLength; i++) {
                if (element.betRespVOs[0].unitPrice * i <= element.betRespVOs[0].maxBetAmtMul * element.betRespVOs[0].unitPrice) {
                  this.betAmtArray.push(element.betRespVOs[0].unitPrice * i);
                }
              }
            }
            this.fetchDataStatus = true;
            this.tempCounter = 0;
            clearInterval(this.timeIntervalContainer);
            if (response.timerType == element.gameCode || response.timerType == "") {
              let tempTime = 0;
              let tempTime2 = 0;
              let fetchRuleStatus = true;
              if (element.drawRespVOs.length != 0) {
                // tempTime = Math.floor((new Date(element.timeToFetchUpdatedGameInfo.replace(/-/g, "/")).getTime() - new Date().getTime()) / 1000);
                tempTime = Math.floor((new Date(this.drawService.changeDateFormat(element.timeToFetchUpdatedGameInfo)).getTime() - DrawService.gameTime) / 1000);
                if (typeof element.drawRespVOs[0].drawSaleStartTime != 'undefined') {
                  tempTime2 = Math.floor((new Date(this.drawService.changeDateFormat(element.drawRespVOs[0].drawSaleStartTime)).getTime() - DrawService.gameTime) / 1000);
                }
              } else {
                this.activeDrawStatus = false;
                this.renderer.addClass(document.body, 'modal-fix');
              }
              this.diff_time = {
                totalTime: tempTime >= 0 ? tempTime : 0,
                shownTime: ['00', '00', '00', '00'],
                convention: 'sec',
                saleStartTime: tempTime2 >= 0 ? tempTime2 : 0,
                saleShownTime: ['00', '00', '00', '00'],
                saleConvention: 'sec',
                fetchRuleStatus: fetchRuleStatus
              }
            }
            ++this.gameFetchCounter;
          }
        });
        this.fetchPlayerTicketList();
        this.updateClock();
        this.timeIntervalContainer = setInterval(() => {
          this.updateClock();
        }, 1000);
        setTimeout(() => {
          let tempUserData = this.commonService.getUserPurchaseData(Constants.DRAW_ENGINE);
          if (tempUserData) {
            delete tempUserData.extra;
            this.userData = JSON.parse(JSON.stringify(tempUserData));
            this.commonService.removeUserPurchaseData();
            this.purchaseTicket();
            for (let i = 0; i < this.userData.panelData.length; i++) {
              this.panelTotNumbersArray[this.userData.panelData[i].pickedValues[0]] = this.userData.panelData[i].totalNumbers;
            }
            this.defaultBetAmountMultiple = this.userData.panelData[0].betAmountMultiple;
            if (this.activateOtherAmt()) {
              this.otherBetAmountMultiple = this.userData.panelData[0].betAmountMultiple;
              this.showOtherAmountInput = true;
              this.betError = '';
              this.changePanelsBet(this.otherBetAmountMultiple);
              this.otherAmtVal = "" + (parseFloat(this.gameData.betRespVOs[0].unitPrice) * this.otherBetAmountMultiple);
            }
          }
        }, 0);
        this.commonService.iframe_resize();
      });
    this.resetPlaySubscription = this.drawService.subscribeResetPlayUserData().subscribe((response) => {
      if (response.status) {
        this.resetUserData();
      }
      this.commonService.iframe_resize();
    });
    this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().subscribe((response) => {
      this.userInfo = response;
      this.commonService.iframe_resize();
    });
    this.notifyTktLstSubscription = this.drawService.subscribeTicketList().subscribe((response) => {
      this.fetchPlayerTicketList();
    });
    this.updateUserDataSubscription = this.drawService.subscribeUpdateUserData().subscribe((response: any) => {
      if (response.userData.panelData.length == 0) {
        this.resetUserData();
      } else {
        this.userData = response.userData;
        this.panelTotNumbersArray = {};
        for (let i = 0; i < this.gameData.numberConfig.range[0].ball.length; i++) {
          this.panelTotNumbersArray[this.gameData.numberConfig.range[0].ball[i].number] = 0;
        }
        for (let i = 0; i < this.userData.panelData.length; i++) {
          this.panelTotNumbersArray[this.userData.panelData[i].pickedValues] = this.userData.panelData[i].totalNumbers;
        }
      }
      this.commonService.iframe_resize();
    });
  }

  ngOnDestroy(): void {
    this.removeBetPanels();
    this.commonService.closeAllModals();
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.removeClass(document.body, 'modal-fix');
    this.renderer.removeClass(document.body, 'screen_type_single');
    clearInterval(this.timeIntervalContainer);
    clearInterval(this.postStateInterval);
    if (typeof this.gameDataSubscription != 'undefined') {
      this.gameDataSubscription.unsubscribe();
    }
    if (typeof this.resetPlaySubscription != 'undefined') {
      this.resetPlaySubscription.unsubscribe();
    }
    if (typeof this.userInfoLocalSubscription != 'undefined') {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.notifyDrawMachineSubscription != 'undefined') {
      this.notifyDrawMachineSubscription.unsubscribe();
    }
    if (typeof this.ticketListSubscription != 'undefined') {
      this.ticketListSubscription.unsubscribe();
    }
    if (typeof this.notifyTktLstSubscription != 'undefined') {
      this.notifyTktLstSubscription.unsubscribe();
    }
    if (typeof this.updateUserDataSubscription != 'undefined') {
      this.updateUserDataSubscription.unsubscribe();
    }
    if (typeof this.routeSubscription != 'undefined') {
      this.routeSubscription.unsubscribe();
    }
    this.commonService.iframe_resize();
  }

  loadBackPanel() {
    this.removeBetPanels();
    this.resetUserData();
    this.commonService.iframe_resize();
  }

  removeBetPanels() {
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-mainbet');
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-sidebet');
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-confirm');
    this.commonService.iframe_resize();
  }

  resetUserData() {
    this.userData = {
      // "currencyCode": (typeof this.gameData != 'undefined' && typeof this.gameData.currencyRespVOs != 'undefined') ? this.gameData.currencyRespVOs[0].currencyCode : '',
      "drawData": [],
      "gameCode": this.gameCode,
      "gameId": (typeof this.gameData != 'undefined' && typeof this.gameData.id != 'undefined') ? this.gameId : 0,
      "isAdvancePlay": false,
      "lastTicketNumber": 0,
      "noOfDraws": 1,
      "noOfPanel": 0,
      "panelData": [
        {
          "betType": this.gameData.betRespVOs[0].betCode,
          "pickType": this.gameData.betRespVOs[0].pickTypeData.pickType[0].code,
          "pickConfig": this.gameData.betRespVOs[0].pickTypeData.pickType[0].range[0].pickConfig,
          "betAmountMultiple": (this.gameData.betRespVOs[0].unitPrice < 1) ? (this.gameData.betRespVOs[0].unitPrice * 10) : 1,
          "quickPick": false,
          "pickedValues": "",
          "qpPreGenerated": false,
          "totalNumbers": 0,
        },
      ],
      "isUpdatedPayoutConfirmed": false,
    };
    this.panelTotNumbersArray = {};
    for (let i = 0; i < this.gameData.numberConfig.range[0].ball.length; i++) {
      this.panelTotNumbersArray[this.gameData.numberConfig.range[0].ball[i].number] = 0;
    }
    this.defaultBetAmountMultiple = (this.gameData.betRespVOs[0].unitPrice < 1) ? (this.gameData.betRespVOs[0].unitPrice * 10) : 1;
    this.panelNumberCounter = +this.gameData.maxPanelAllowed;
    this.postStateMsg = this.gameData.betRespVOs[0].pickTypeData.pickType[0].description;
    // this.postStateMsg = this.translate.instant('dge.' + this.gameCode + '_' + this.gameData.betRespVOs[0].betCode + '_' + this.gameData.betRespVOs[0].pickTypeData.pickType[0].code + '_desc');
    this.otherAmtVal = '';
    this.clearPickValues = false;
    this.showOtherAmountInput = false;
    this.commonService.iframe_resize();
  }

  findPanelIndex(num) {
    let index = 0;
    for (let i = 0; i < this.userData.panelData.length; i++) {
      // if (this.userData.panelData[i].pickedValues == num && this.userData.panelData[i].totalNumbers > 0) {
      if (this.userData.panelData[i].manuallyGenatedNum == num && this.userData.panelData[i].totalNumbers > 0) {
        index = i;
        return index;       
      }
    }
    return false;
  }

  selectPickedNum(num, pickedValues?, pickConfig?, pickType?, betType?) {                                 
    if (this.clearPickValues) { 
      let tempPanelIndex = this.findPanelIndex(num);                        
      if(tempPanelIndex != false) {
        this.userData.panelData.splice(tempPanelIndex, 1);
        this.panelTotNumbersArray[num] = 0;
      }               
    } else {       
      if (this.panelTotNumbersArray[num] >= 1) {
        let tempPanelIndex = this.findPanelIndex(num).toString();
        this.userData.panelData[parseInt(tempPanelIndex)].betAmountMultiple += this.defaultBetAmountMultiple;
        this.panelTotNumbersArray[num] += this.defaultBetAmountMultiple;    
      } else {        
        if (this.userData.panelData.length > this.gameData.maxPanelAllowed) {
            this.alertService.error(this.translate.instant('dge.max_pan_err', { maxPanelAllowed: this.gameData.maxPanelAllowed }));
            return false;
          } else {
            this.userData.panelData.push({
              "betType": betType ? betType : this.gameData.betRespVOs[0].betCode,                                                   //  Direct1                
              "pickType": pickType ? pickType : this.gameData.betRespVOs[0].pickTypeData.pickType[0].code,                            //  Direct1            
              "pickConfig": pickConfig ? pickConfig :this.gameData.betRespVOs[0].pickTypeData.pickType[0].range[0].pickConfig,           //  Number
              "betAmountMultiple": this.defaultBetAmountMultiple,
              "quickPick": false,
              "pickedValues": pickedValues && typeof(pickedValues) == 'object' ? pickedValues : [num],                                                                            // []         "" + num
              "qpPreGenerated": false,
              "totalNumbers": this.defaultBetAmountMultiple,
              "manuallyGenatedNum": num
            });        
            this.panelTotNumbersArray[num] = this.defaultBetAmountMultiple;
          }
      }           
    }
    this.userData.noOfPanel = this.userData.panelData.length;                
    this.commonService.iframe_resize();
  }       

  changePanelsBet(amt, isClear = false) {
    if(!isClear) {
      // for (let i = 0; i < this.userData.panelData.length; i++) {
      //   this.userData.panelData[i].betAmountMultiple = amt;
      // }
      this.defaultBetAmountMultiple = amt;    
    } 
    this.clearPickValues = isClear;       
  }

  selectBetAmount(j, betAmt) {
    // event.stopPropagation();
    this.showOtherAmountInput = false;
    this.otherAmtVal = '';
    if (this.gameData.betRespVOs[0].unitPrice < 1) {
      this.changePanelsBet((j + 1) * 10);
    } else {
      this.changePanelsBet((j + 1));
    }
    this.betError = '';
    this.commonService.iframe_resize();
  }

  selectOtherAmount(event) {
    if (!this.showOtherAmountInput) {
      this.showOtherAmountInput = true;
      this.betError = '';
      this.changePanelsBet(0);
      this.otherAmtVal = '';
      setTimeout(() => {
        document.getElementById('otherAmt-' + this.panelCounter).focus();
        this.commonService.iframe_resize();
        // event.srcElement.parentNode.children[1].focus();
      }, 500);
    }
    this.commonService.iframe_resize();
  }

  activateOtherAmt() {
    if (typeof this.userData != 'undefined') {
      let index = this.betAmtArray.indexOf(this.userData.panelData[this.panelCounter - 1].betAmountMultiple * this.gameData.betRespVOs[0].unitPrice);
      if ((index > -1 && index > 5) || (index < 0)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  onMouseEnter(event) {
      let str = event.target.id;
      let sub_var = "." + str.replace("parent", "sub");
      let subVarData = this.el.nativeElement.querySelectorAll(sub_var);
      for(let data of subVarData) {
        data.classList.add('selectedCell');
      }
  }

  onMouseLeave(event) {
    let str = event.target.id;
    let sub_var = "." + str.replace("parent_", "sub_");
    let subVarData = this.el.nativeElement.querySelectorAll(sub_var);
    for(let data of subVarData) {
      data.classList.remove('selectedCell');
    }
  }

  onOtherAmtInputChange(event) {
    let regex = /[^0-9.]/g;
    const initalValue = this.otherAmtVal;
    this.otherAmtVal = initalValue.replace(regex, '');
    let formatVal = parseFloat(this.otherAmtVal).toFixed(1);
    if (formatVal == 'NaN' && this.otherAmtVal == '.') {
      this.otherBetAmountMultiple = 0;
      this.otherAmtVal = '0.'
    } else if (formatVal == 'NaN' && this.otherAmtVal == '') {
      this.otherBetAmountMultiple = 0;
    } else if (formatVal == '0.0' && this.otherAmtVal != '0.0') {
      this.otherBetAmountMultiple = 0;
      if ((this.otherAmtVal.match(/[.]/g) || []).length > 1 || (this.otherAmtVal.match(/0/g) || []).length > 1) {
        this.otherAmtVal = formatVal;
      }
    } else {
      let remainder = parseFloat(formatVal) % parseFloat(this.gameData.betRespVOs[0].unitPrice);
      if (remainder == 0 && formatVal != '0.0') {
        let quotient = parseFloat(formatVal) / parseFloat(this.gameData.betRespVOs[0].unitPrice);
        if (quotient <= this.gameData.betRespVOs[0].maxBetAmtMul) {
          // if (parseFloat(formatVal) <= this.gameData.betRespVOs[0].maxBetAmtMul) {
          this.otherBetAmountMultiple = quotient;
          if ((this.otherAmtVal.match(/[.]/g) || []).length > 1) {
            this.otherAmtVal = formatVal;
          } else if (this.otherAmtVal.indexOf('.') > -1 && this.otherAmtVal.indexOf('.') != (this.otherAmtVal.length - 1)) {
            this.otherAmtVal = formatVal;
          }
          this.betError = '';
        } else {
          this.betError = this.translate.instant('dge.beterr_amt_mul_max', { mul: this.gameData.betRespVOs[0].unitPrice, max: (this.gameData.betRespVOs[0].unitPrice * this.gameData.betRespVOs[0].maxBetAmtMul) });
          // this.betError = this.translate.instant('dge.beterr_amt_mul_max', { mul: this.gameData.betRespVOs[0].unitPrice, max: this.gameData.betRespVOs[0].maxBetAmtMul });
          this.otherBetAmountMultiple = 0;
        }
      } else {
        this.betError = this.translate.instant('dge.beterr_amt_mul', { mul: this.gameData.betRespVOs[0].unitPrice });
        this.otherBetAmountMultiple = 0;
      }
    }
    /*********************For Input Button specific || remove IT for modal **********************/
    this.changePanelsBet(this.otherBetAmountMultiple);
    /********************************************************************************************/
    this.commonService.iframe_resize();
  }

  purchaseTicket() {
    if (this.userInfo.sessid == '-' && this.userInfo.playerid == '-' && Constants.CLIENT_MULTI_CURRENCY[Constants.CLIENT_CODE]) {
      this.commonService.openPlayerLogin();
      return false;
    }
    if (this.userData.noOfPanel == 0) {
      this.alertService.error(this.translate.instant('dge.add_bet_err'));
      return false;
    }
    if(this.userData.panelData[0].pickedValues == '') {
      this.userData.panelData.shift();     
    }                     
    this.drawService.setPayoutPanelStatus(false);
    this.removeBetPanels();
    this.drawService.setTicketStatus(true, this.userData);
    this.commonService.iframe_resize();
  }

  panelCount() {
    if (typeof this.userData != 'undefined') {
      let totalLine = 0;
      for (let i = 0; i < this.userData.panelData.length; i++) {
        totalLine += this.numberOfLines(i);
        //totalLine = this.userData.panelData.length;
      }
      return totalLine;
    }
    return 0;
  }

  numberOfLines(purchasePanelIndex) {
    if (typeof this.userData != 'undefined') {
      if (this.userData.panelData[purchasePanelIndex].betType != '' && this.userData.panelData[purchasePanelIndex].pickedValues != "") {
        this.changePostState(false);
        return this.userData.panelData[purchasePanelIndex].betAmountMultiple;
      } else {
        this.changePostState(true);
        // this.postState = true;
        return 0;
      }
    } else {
      this.changePostState(true);
      // this.postState = true;
      return 0;
    }
    this.commonService.iframe_resize();
  }

  calculatePanelPrice(pIndex) {
    if (typeof this.userData != 'undefined' && typeof this.betData[this.userData.panelData[pIndex].betType] != 'undefined') {
      let unitPrice = this.betData[this.userData.panelData[pIndex].betType].unitPrice;
      //let betAmountMultiple = this.userData.panelData[pIndex].betAmountMultiple;
      return (unitPrice  * this.numberOfLines(pIndex) * this.userData.noOfDraws);
    }
    return 0;
    this.commonService.iframe_resize();
  }

  calculateTotalPrice() {
    if (typeof this.userData != 'undefined') {
      let totalSum = 0;
      this.changePostState(true);
      for (let i = 0; i < this.userData.panelData.length; i++) {
        totalSum += this.calculatePanelPrice(i);
      }
      return totalSum;
    }
    return 0;
    this.commonService.iframe_resize();
  }

  updateClock() {
    if (this.diff_time.totalTime > -1 && this.diff_time.fetchRuleStatus) {
      let diff_day = Math.floor(this.diff_time.totalTime / (3600 * 24));
      let diff_hr = Math.floor((this.diff_time.totalTime % (3600 * 24)) / 3600);
      let diff_min = Math.floor((this.diff_time.totalTime % (3600)) / 60);
      let diff_sec = Math.floor(this.diff_time.totalTime % 60);
      this.diff_time.shownTime[0] = (diff_day > 9) ? '' + diff_day : '0' + diff_day;
      this.diff_time.shownTime[1] = (diff_hr > 9) ? '' + diff_hr : '0' + diff_hr;
      this.diff_time.shownTime[2] = (diff_min > 9) ? '' + diff_min : '0' + diff_min;
      this.diff_time.shownTime[3] = (diff_sec > 9) ? '' + diff_sec : '0' + diff_sec;
      if (diff_day > 0) {
        // this.diff_time.convention = (diff_day == 1) ? 'day' : 'days';
        this.diff_time.convention = 'day';
      } else if (diff_hr > 0) {
        // this.diff_time.convention = (diff_hr == 1) ? 'hr' : 'hrs';
        this.diff_time.convention = 'hr';
      } else if (diff_min > 0) {
        // this.diff_time.convention = (diff_min == 1) ? 'min' : 'mins';
        this.diff_time.convention = 'min';
      } else if (diff_sec > 0) {
        // this.diff_time.convention = (diff_sec == 1) ? 'sec' : 'secs';
        this.diff_time.convention = 'sec';
      } else {
        this.diff_time.convention = 'sec';
        ++this.tempCounter;
        if (this.fetchDataStatus || this.tempCounter == 1) {
          localStorage.removeItem(this.gameCode + '-drawGameData');
          this.drawService.getGameData(Constants.DRAW_ENGINE, this.gameCode);
          // this.notifyDrawMachineSubscription = this.commonService.notifyDrawMachine({ 'engine': Constants.DRAW_ENGINE, 'gameCode': this.gameCode }).subscribe((response: any) => {
          // });
          // this.drawService.setLoaderStatus(true);
        }
        this.fetchDataStatus = false;
      }
      --this.diff_time.totalTime;
    }
    if (this.diff_time.saleStartTime > 0) {
      this.saleTimerStatus = true;
      this.renderer.addClass(document.body, 'modal-fix');
      let diff_day = Math.floor(this.diff_time.saleStartTime / (3600 * 24));
      let diff_hr = Math.floor((this.diff_time.saleStartTime % (3600 * 24)) / 3600);
      let diff_min = Math.floor((this.diff_time.saleStartTime % (3600)) / 60);
      let diff_sec = Math.floor(this.diff_time.saleStartTime % 60);
      this.diff_time.saleShownTime[0] = (diff_day > 9) ? '' + diff_day : '0' + diff_day;
      this.diff_time.saleShownTime[1] = (diff_hr > 9) ? '' + diff_hr : '0' + diff_hr;
      this.diff_time.saleShownTime[2] = (diff_min > 9) ? '' + diff_min : '0' + diff_min;
      this.diff_time.saleShownTime[3] = (diff_sec > 9) ? '' + diff_sec : '0' + diff_sec;
      if (diff_day > 0) {
        // this.diff_time.saleConvention = (diff_day == 1) ? 'day' : 'days';
        this.diff_time.convention = 'day';
      } else if (diff_hr > 0) {
        // this.diff_time.saleConvention = (diff_hr == 1) ? 'hr' : 'hrs';
        this.diff_time.convention = 'hr';
      } else if (diff_min > 0) {
        // this.diff_time.saleConvention = (diff_min == 1) ? 'min' : 'mins';
        this.diff_time.convention = 'min';
      } else if (diff_sec > 0) {
        // this.diff_time.saleConvention = (diff_sec == 1) ? 'sec' : 'secs';
        this.diff_time.convention = 'sec';
      } else {
        this.diff_time.saleConvention = 'sec';
      }
      --this.diff_time.saleStartTime;
    } else {
      this.saleTimerStatus = false;
      if (this.activeDrawStatus) {
        this.renderer.removeClass(document.body, 'modal-fix');
      }
    }
  }

  changePostState(val) {
    clearInterval(this.postStateInterval);
    this.postStateInterval = setInterval(() => {
      this.postState = val;
    }, 0);
  }

  fetchPlayerTicketList() {
    if (typeof this.userInfo == 'undefined' || this.userInfo.sessid == '-' || this.gameData.drawRespVOs.length == 0) {
      this.myTicketCount = 0;
      return false;
    }
    let temp = {
      gameCode: this.gameCode,
      orderBy: 'asc',
      pageSize: 100,
      pageIndex: 0,
      drawId: this.gameData.drawRespVOs[0].drawId,
    };
    this.ticketListSubscription = this.drawService.fetchPlayerTicketList(temp).subscribe((response: any) => {
      if (typeof response != 'undefined' && typeof response.data != 'undefined' && response.data.responseCode == 0 && response.data.responseData.length > 0 && response.data.responseData[0].ticketList != null) {
        this.myTicketCount = response.data.responseData[0].ticketList.length;
      } else {
        this.myTicketCount = 0;
        // this.alertService.error(response.responseMessage);
      }
    });
  }

  navigateTicketList() {
    if (this.myTicketCount > 0) {
      this.router.navigate(['/dge/my-tickets']);
    } else {
      return false;
    }
  }

  openDrawMachine() {
    if (this.myTicketCount > 0) {
      this.router.navigate(['/dge/draw-machine'], { fragment: this.gameCode });
    } else {
      return false;
    }
  }

  openHelpModal(gameCode) {
    this.drawService.openHelpPopup(true, gameCode);
    this.commonService.iframe_resize();
  }

  loadBack() {
    if (this.loadLobby) {
      this.router.navigate(['/dge/lobby']);
    } else {
      this.commonService.appLobbyBack();
      this.commonService.redirectParent('loadBackUrl');
    }
  }

}

                 